import React from "react";
import { Bar, Line } from "react-chartjs-2";
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseIcon from "@material-ui/icons/Close";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import MinimizeIcon from "@material-ui/icons/Minimize";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (state) =>
      state.page !== "update"
        ? theme.palette.primary.main
        : theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
  title: {
    flexGrow: 1,
  },
  icon: {
    padding: "0.3em",
  },
  chartBox: {
    padding: isMobile ? "1em" : "3em",
  },
}));

export default function Qestion({ data }) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper} elevation={2}>
      <Grid
        className={classes.chartBox}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Typography component="h1" variant="h5">
          Sorular
        </Typography>
        <Line
          data={data}
          options={{
            maintainAspectRatio: true,
            scales: {
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    min: 0,
                  },
                },
              ],
            },
          }}
        />
      </Grid>
    </Paper>
  );
}
